var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'level-item': true,
    button: true,
    'is-toggle': true,
    'is-on': _vm.buttonIsOn
  },attrs:{"title":_vm.$t(_vm.buttonIsOn ? 'tasks.hide_infos' : 'tasks.show_infos')},on:{"click":_vm.toggleInfos}},[_c('database-icon',{staticClass:"icon is-small"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }